import React from 'react';

const deployItems = [
  {
    title: 'CV and application parsing',
    description: 'Any format. Structured data extracted from every application.',
  },
  {
    title: 'Criteria-based scoring',
    description: 'Structured requirements, written rationale for every score. No black box.',
  },
  {
    title: 'Outreach and scheduling',
    description: 'Personalised drafts reviewed by a recruiter before sending.',
  },
  {
    title: 'ATS sync',
    description: 'Statuses, notes and scores written back to your applicant tracking system.',
  },
];

const safeguards = [
  'Human approval on every rejection and advancement.',
  'Protected characteristics excluded from scoring.',
  'Explainable written rationale per candidate.',
  'Retention and deletion to your policy. Bias monitoring across cohorts.',
];

const HirePage: React.FC = () => {
  return (
    <>
      <section className="section-padding bg-white">
        <div className="container-max">
          <p className="text-sm text-neutral-500 mb-3">Zwift Hire</p>
          <h1 className="text-4xl md:text-5xl font-semibold text-black leading-[1.05] tracking-[-0.02em] mb-5 max-w-3xl">
            Shortlist candidates in hours, not weeks.
          </h1>
          <p className="text-lg text-neutral-600 leading-relaxed max-w-2xl mb-3">
            Screen, score and engage without bias or data you cannot defend.
          </p>
          <p className="text-sm text-neutral-400 mb-6">
            The engine behind AwesomeHires, deployed into your own stack.
          </p>
          <div className="flex flex-wrap gap-2">
            {['GDPR', 'EU AI Act'].map((tag) => (
              <span key={tag} className="inline-flex items-center text-xs font-medium text-neutral-500 bg-neutral-100 px-2.5 py-1 rounded-full">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-neutral-50">
        <div className="container-max">
          <h2 className="text-3xl font-semibold text-black tracking-tight mb-10">What we deploy</h2>
          <div className="grid md:grid-cols-2 gap-5">
            {deployItems.map((item, i) => (
              <div key={item.title} className="bg-white rounded-2xl p-6 border border-neutral-200">
                <span className="text-xs font-medium text-neutral-300 block mb-3">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="text-lg font-semibold text-black mb-2">{item.title}</h3>
                <p className="text-neutral-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-max">
          <h2 className="text-3xl font-semibold text-black tracking-tight mb-8">Safeguards</h2>
          <ul className="space-y-4 max-w-2xl">
            {safeguards.map((s) => (
              <li key={s} className="flex items-start gap-3">
                <svg className="w-5 h-5 text-black shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-neutral-600 leading-relaxed">{s}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section-padding bg-neutral-50">
        <div className="container-max">
          <h2 className="text-3xl font-semibold text-black tracking-tight mb-4">Used in</h2>
          <div className="flex flex-wrap gap-2">
            {['Staffing agencies', 'Healthcare staffing', 'Logistics', 'Enterprise HR'].map((industry) => (
              <span key={industry} className="inline-flex items-center text-sm font-medium text-neutral-600 bg-white border border-neutral-200 px-3 py-1.5 rounded-full">
                {industry}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-black">
        <div className="container-max">
          <h2 className="text-3xl font-semibold text-white mb-4">
            Ready to discuss Zwift Hire?
          </h2>
          <p className="text-neutral-400 mb-8 max-w-xl">
            Book a free fit call. We will check whether Zwift Hire is the right fit and tell you honestly.
          </p>
          <a
            href="https://calendar.app.google/cnN9KoLp6WZYMX9G7"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-white hover:bg-neutral-100 text-black font-medium px-7 py-3.5 rounded-full transition-colors"
          >
            Book a fit call to discuss Zwift Hire
          </a>
        </div>
      </section>
    </>
  );
};

export default HirePage;
